import api from './api';

export const userService = {
  // Get all users
  getAllUsers: async () => {
    const response = await api.get('/users');
    return response.data;
  },

  // Get user by ID
  getUserById: async (id) => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  // Get user by email
  getUserByEmail: async (email) => {
    const response = await api.get(`/users/email/${email}`);
    return response.data;
  },

  // Check if email is available (not already in use)
  checkEmailAvailability: async (email) => {
    try {
      const response = await api.get(`/users/check-email-availability/${email}`);
      return response.data;
    } catch (error) {
      // Provide more specific error handling
      if (error.response) {
        const status = error.response.status;
        if (status === 401) {
          throw new Error('Authentication required to check email availability');
        } else if (status === 500) {
          throw new Error('Server error while checking email availability');
        } else {
          throw new Error(`Failed to check email availability (Status: ${status})`);
        }
      } else if (error.message) {
        if (error.message.includes('Network Error') || error.message.includes('timeout')) {
          throw new Error('Network error while checking email availability');
        } else {
          throw new Error(error.message);
        }
      } else {
        throw new Error('Unable to check email availability');
      }
    }
  },

  // Get users by role
  getUsersByRole: async (roleName) => {
    const response = await api.get(`/users/role/${roleName}`);
    return response.data;
  },

  // Get users by group
  getUsersByGroup: async (groupName) => {
    const response = await api.get(`/users/group/${groupName}`);
    return response.data;
  },

  // Get users seeking team
  getUsersSeekingTeam: async () => {
    const response = await api.get('/users/seeking-team');
    return response.data;
  },

  // Get users seeking team with group information
  getTeamSeekingUsersWithGroups: async () => {
    const response = await api.get('/users/seeking-team-with-groups');
    return response.data;
  },

  // Search users
  searchUsers: async (searchTerm) => {
    const response = await api.get(`/users/search?q=${encodeURIComponent(searchTerm)}`);
    return response.data;
  },

  // Create user
  createUser: async (userData) => {
    const response = await api.post('/users', userData);
    return response.data;
  },

  // Signup user (public endpoint, no authentication required)
  signupUser: async (userData) => {
    const response = await api.post('/auth/signup', userData);
    return response.data;
  },

  // Caregiver signup with automatic login (returns JWT tokens)
  caregiverSignup: async (userData) => {
    const response = await api.post('/auth/caregiver-signup', userData);
    return response.data;
  },

  // Add caregiver to existing household (no auto-login)
  addCaregiverToHousehold: async (userData) => {
    const response = await api.post('/auth/add-caregiver-to-household', userData);
    return response.data;
  },

  // Update user
  updateUser: async (id, userData) => {
    const response = await api.put(`/users/${id}`, userData);
    return response.data;
  },

  // Update team seeking status only
  updateTeamSeekingStatus: async (id, seekingTeam) => {
    const response = await api.put(`/users/${id}/team-seeking`, { seekingTeam });
    return response.data;
  },

  // Delete user
  deleteUser: async (id) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },
}; 